import { initializeApp } from "firebase/app";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Keep in sync with AdminCRM/src/firebase/config.js (see AGENTS.md)
const firebaseConfig = {
    apiKey: "AIzaSyDm82ZbERH7Em1tKtAuU_zPRFFFhmnMniw",
    authDomain: "tint-bolt-1aba6.firebaseapp.com",
    // The Emulator Suite is started with `--project demo-agent-outbox`, and
    // Firestore/Auth data is namespaced by project ID even on localhost.
    // Keep the local Dashboard in that same namespace so it sees the seeded
    // owner instead of creating an empty tint-bolt-1aba6 emulator user.
    projectId:
        process.env.VUE_APP_USE_EMULATORS === "true"
            ? (process.env.VUE_APP_EMULATOR_PROJECT_ID || "demo-agent-outbox")
            : "tint-bolt-1aba6",
    storageBucket: "tint-bolt-1aba6.firebasestorage.app",
    messagingSenderId: "515297312486",
    appId: "1:515297312486:web:ea3ce7ec09aacf8ba24527",
    measurementId: "G-K5N24X9ZZE",
};

const app = initializeApp(firebaseConfig);

const projectFirestore = getFirestore(app);
const projectAuth = getAuth(app);
const projectStorage = getStorage(app);
const functions = getFunctions(app, "us-central1");

const timestamp = serverTimestamp();

export {
    app,
    firebaseConfig,
    projectFirestore,
    projectAuth,
    projectStorage,
    timestamp,
    functions,
};
